<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M1799.16 2723.11c-186.48,0 -336,-151.18 -336,-335.94 0,-186.48 149.52,-336.01 336,-336.01 185.53,-0.06 336,150.42 336,335.94 0,185.53 -150.47,336.01 -336,336.01l0 0zm1007.95 504l0 -1679.95 -2015.9 0 0 1679.95 2015.9 0 0 0zm0 -2015.89c185.52,-0.07 336,150.41 336,335.94l0 1679.95c0,185.46 -150.48,335.94 -336,335.94l-2015.9 0c-186.47,0 -336,-151.18 -336,-335.94l0 -1679.95c0,-186.48 149.53,-335.94 336,-335.94l168.01 0 0 -336.01c0.06,-463.81 376.19,-839.94 839.94,-839.94 463.81,0 839.94,376.13 839.94,839.94l0 336.01 168.01 0 0 0zm-1007.95 -840.01c-278.23,0 -503.94,225.72 -503.94,504l-0.07 336.01 1008.02 0 0 -336.01c0,-278.28 -225.72,-504 -504.01,-504z"/>
  </g>
 </g>
</svg>
